@if (spinning) {
  <mat-progress-bar
    #progressbar
    mode="indeterminate"
    ></mat-progress-bar
    >
    }<app-dialog-structure
    [title]="data ? 'Edit GSA' : 'Add GSA'"
    [submitButton]="data ? 'SAVE' : 'ADD'"
    (cancel)="cancel()"
    (submit)="submitEmitter()"
    [disableAction]="gsaForm.invalid || !contactsValiadtion()"
    >
    <div class="display-layout-column layout-gap-15">
      <div [formGroup]="gsaForm" class="display-layout-row layout-gap-32">
        <div class="display-layout-column" style="flex: 50%;">
          <mat-form-field >
            <mat-label  >GSA Name</mat-label>
            <input matInput formControlName="gsaName" type="text" required class="display-flex" />
            @if (gsaForm.controls['gsaName'].hasError('required')) {
              <mat-error>
                GSA Name is <strong>required</strong>
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field>
            <mat-label>GSA Status</mat-label>
            <mat-select formControlName="status" required>
              @for (status of status; track status) {
                <mat-option [value]="status.value"
                  >{{ status.viewValue }}
                </mat-option>
              }
            </mat-select>

            @if (gsaForm.controls['status'].hasError('required')) {
              <mat-error>
                GSA Status is <strong>required</strong>
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>

      <mat-divider></mat-divider>

      <mat-accordion>
        <!--CONTACTS-->
        <mat-expansion-panel expanded=true>
          <mat-expansion-panel-header>
            <mat-panel-title> Contacts </mat-panel-title>
            <mat-panel-description>
              @if (contactsValiadtion()) {
                <div>Specify the GSA contacts</div>
              }
              @if (!contactsValiadtion()) {
                <div class="warning">
                  Please make sure that contacts are defined!
                </div>
              }
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="display-layout-column layout-align-center-center">
            <div class="display-layout-row layout-gap-25">
              <div class="display-layout-column" [formGroup]="contactsForm">
                <mat-form-field>
                  <mat-label>Contact Person</mat-label>
                  <input
                    matInput
                    formControlName="contactName"
                    type="text"
                    required
                    />
                  @if (
                    contactsForm.controls['contactName'].hasError('required')
                    ) {
                    <mat-error
                      >
                      Name of the Contact Person is <strong>required</strong>
                    </mat-error>
                  }
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Contact Mail</mat-label>
                  <input
                    matInput
                    formControlName="contactMail"
                    type="text"
                    required
                    />
                  @if (
                    contactsForm.controls['contactMail'].hasError('required')
                    ) {
                    <mat-error
                      >
                      Email of the Contact Person is <strong>required</strong>
                    </mat-error>
                  }
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Contact Phonenumber</mat-label>
                  <input
                    matInput
                    formControlName="phoneNumber"
                    type="text"
                    required
                    />
                  @if (
                    contactsForm.controls['phoneNumber'].hasError('required')
                    ) {
                    <mat-error
                      >
                      Phonenumber of the Contact Person is
                      <strong>required</strong>
                    </mat-error>
                  }
                </mat-form-field>

                <button
                  mat-button
                  [disabled]="contactsForm.invalid"
                  (click)="addContact()"
                  >
                  Add Contact
                </button>
              </div>

              <div >
                <table mat-table [dataSource]="contactsTableSource" >
                  <ng-container matColumnDef="contactName">
                    <th mat-header-cell *matHeaderCellDef>Name</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.contactPerson }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="contactMail">
                    <th mat-header-cell *matHeaderCellDef>Mail</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.contactMail }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="contactPhone">
                    <th mat-header-cell *matHeaderCellDef>Phone</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.phoneNumber }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element; let i = index">
                      <button mat-icon-button (click)="deleteContact(i)">
                        <mat-icon>delete_outline</mat-icon>
                      </button>
                    </td>
                  </ng-container>

                  <tr
                    mat-header-row
                    *matHeaderRowDef="displayedContactColumns"
                  ></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: displayedContactColumns"
                  ></tr>
                </table>
                <mat-paginator
                  #paginator
                  [length]="contactsTableSource.data.length"
                  [pageSizeOptions]="[5, 10, 20]"
                  showFirstLastButtons
                ></mat-paginator>
              </div>
            </div>
          </div>
        </mat-expansion-panel>

        <!-- AIRLINES -->
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>Airlines</mat-panel-title>
            <mat-panel-description
              >Specify the GSA airlines</mat-panel-description
              >
            </mat-expansion-panel-header>
            <div class="display-layout-column" [formGroup]="searchForm">
              <mat-form-field>
                <mat-label>Search</mat-label>
                <input formControlName="filter" matInput (keyup)="applyFilter()" />

                <mat-icon matPrefix>search </mat-icon>

                @if (searchForm.value.filter != '') {
                  <button
                    matSuffix
                    mat-icon-button
                    (click)="clearSearch()"
                    >
                    <mat-icon matSuffix> clear </mat-icon>
                  </button>
                }
              </mat-form-field>

              <div class="display-layout-column" style="width: 100%;">
                <table mat-table [dataSource]="airlinesTableSource"  >
                  <ng-container matColumnDef="select">
                    <th mat-header-cell *matHeaderCellDef>
                      <mat-checkbox
                        (change)="$event ? masterToggle() : null"
                        [checked]="selection.hasValue() && isAllSelected()"
                        [indeterminate]="selection.hasValue() && !isAllSelected()"
                        [aria-label]="checkboxLabel()"
                        >
                      </mat-checkbox>
                    </th>
                    <td mat-cell *matCellDef="let row">
                      <mat-checkbox
                        (click)="$event.stopPropagation()"
                        (change)="$event ? selection.toggle(row) : null"
                        [checked]="selection.isSelected(row)"
                        [aria-label]="checkboxLabel(row)"
                        >
                      </mat-checkbox>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef>id</th>
                    <td mat-cell *matCellDef="let element">{{ element.id }}</td>
                  </ng-container>

                  <ng-container matColumnDef="airlineName">
                    <th mat-header-cell *matHeaderCellDef>Name</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.airlineName }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="IATA">
                    <th mat-header-cell *matHeaderCellDef>IATA</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.IATA }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef>Phone</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.status }}
                    </td>
                  </ng-container>

                  <tr
                    mat-header-row
                    *matHeaderRowDef="displayedAirlineColumns"
                  ></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: displayedAirlineColumns"
                  ></tr>
                </table>

                <mat-paginator
                  #airlinePaginator
                  [pageSizeOptions]="[5]"
                  showFirstLastButtons
                ></mat-paginator>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </app-dialog-structure>
